import { useEffect, useState } from 'react'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { useCanCount } from '~/hooks/components/use-can-count'

export function useBulkMeter() {
  const cansThreshold = process.env.GATSBY_BULK_DISCOUNT_CANS_THRESHOLD || 72
  const cansPerCase = 24

  const canCount = useCanCount()
  const [cansNeeded, setCansNeeded] = useState(cansThreshold)
  const translate = useTranslate()

  useEffect(() => {
    setCansNeeded(Math.max(0, cansThreshold - canCount))
  }, [canCount, cansThreshold])

  return {
    bulkOrderEligibilityError: translate('cart.meters.bulk.empty', {
      amount: cansThreshold / cansPerCase,
    }),
    casesNeededToBulkOrder: cansNeeded / cansPerCase,
    eligibleToBulkOrder: cansNeeded === 0,
    isEmpty: canCount === 0,
    percentage: (1 - cansNeeded / cansThreshold) * 100,
  }
}
